/* eslint-disable */
import React from "react";
import {NavLink, useLocation} from "react-router-dom";
// chakra imports
import {Box, Flex, HStack, Text, useColorModeValue} from "@chakra-ui/react";
import {useSelector} from "react-redux";
import {RootState} from "../../../store/store.ts";
import routes from '../../../routes.js'

export function SidebarLinks() {
    //   Chakra color mode
    let location = useLocation();
    let activeColor = useColorModeValue("gray.700", "white");
    let activeIcon = useColorModeValue("brand.500", "white");
    let textColor = useColorModeValue("secondaryGray.500", "white");
    let brandColor = useColorModeValue("brand.500", "brand.400");

    const user = useSelector((state: RootState) => state?.user?.user)

    // verifies if routeName is the one active (in browser input)
    const activeRoute = (routeName) => {
        return location.pathname.includes(routeName);
    };

    const createLinks = (routes) => {
        return routes.map((route, index) => {
            if (!user?.isSuperuser && route.name === 'Doctors')
                return null
            else
                return (
                    <NavLink key={index} to={route.layout + route.path}>
                        <Box mb="15px">
                            <HStack
                                spacing="20px"
                                py="6px"
                                px="10px"
                                align="center"
                                justify="space-between"
                            >
                                {/* Icon + Text container */}
                                <Flex align="center" flex="1">
                                    <Box
                                        display="flex"
                                        alignItems="center"
                                        justifyContent="center"
                                        mr="14px"
                                        fontSize="60px" // ⬅️ Increase icon size
                                        color={activeRoute(route.path.toLowerCase()) ? activeIcon : textColor}
                                    >
                                        {route.icon}
                                    </Box>

                                    <Text
                                        fontSize='lg'
                                        fontWeight={
                                            activeRoute(route.path.toLowerCase()) ? "bold" : "normal"
                                        }
                                        color={
                                            activeRoute(route.path.toLowerCase()) ? activeColor : textColor
                                        }
                                    >
                                        {route.name}
                                    </Text>
                                </Flex>

                                {/* Right indicator bar */}
                                <Box
                                    h="36px"
                                    w="4px"
                                    bg={
                                        activeRoute(route.path.toLowerCase()) ? brandColor : "transparent"
                                    }
                                    borderRadius="5px"
                                />
                            </HStack>
                        </Box>
                    </NavLink>
                );
        });
    };
    //  BRAND
    return createLinks(routes);
}

export default SidebarLinks;
